<template>
  <v-container fluid class="ma-0 pa-0">
    <h3 class="mb-4 text-left">{{ $t("formula.variables") }}</h3>
    <div
      v-for="(resource, i) in localValue.resources"
      :key="resource.identifier"
    >
      <formula-resource-form
        v-model="localValue.resources[i]"
        :awaiting="localValue.awaitAllInput"
        :selectableTags="selectableTags"
        class="ma-2"
        :disabled="disabled"
        @newConstant="() => (dialog = true)"
      />
    </div>
    <v-dialog v-model="dialog" min-width="86vh" max-width="90vh">
      <create-constant-form @update="updateConstants" />
    </v-dialog>
  </v-container>
</template>

<script>
import { mapActions } from "vuex";
import FormulaResourceForm from "./FormulaResourceForm.vue";
import CreateConstantForm from "../constant/CreateConstantForm.vue";
export default {
  name: "FormulaResourceSelection",

  props: {
    value: {
      type: Object,
      default: () => ({}),
    },

    variableNames: {
      type: Array,
      default: () => [],
    },

    selectableTags: {
      type: Array,
      default: () => [],
    },

    disabled: {
      type: Boolean,
      default: false,
    },
  },

  model: {
    prop: "value",
  },

  data() {
    return {
      assignedVariables: [],
      dialog: false,
    };
  },

  components: {
    FormulaResourceForm,
    CreateConstantForm,
  },

  methods: {
    ...mapActions("formulas", ["getConstants"]),

    async updateConstants() {
      await this.getConstants();
      this.dialog = false;
    },
  },

  computed: {
    localValue: {
      get() {
        return this.value;
      },

      set(val) {
        this.$emit("input", val);
      },
    },
  },

  async created() {
    await this.getConstants();
  },

  watch: {
    variableNames: {
      //Watcher to setup the resources from the formula identifiers given in variableNames
      handler(val) {
        if (this.disabled) return;
        this.localValue.resources = this.localValue.resources.filter((x) =>
          val.includes(x.identifier)
        );
        val.forEach((x) => {
          let resource = this.localValue.resources.find(
            (y) => y.identifier == x
          );
          if (resource == undefined) {
            resource = {
              identifier: x,
              triggerOnChange: true,
              deveui: null,
              key: null,
              constantId: null,
            };
            if (this.localValue.formulaId)
              resource.formulaId = this.localValue.formulaId;

            this.localValue.resources.push(resource);
          }
        });
      },
    },
  },
};
</script>
